//-----------------------imports----------------
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import { useStyles } from "../../assets/styles/Theme";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";

import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";

import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  SETTINGS_API_02,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";

// const names = ["Food Items", "Beverages", "Other Items"];

const names = [
  { label: "Food Items", value: "F" },
  { label: "Beverages", value: "B" },

  { label: "Other Items", value: "O" },
];

const Category = () => {
  //----------------------hooks---------------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const [errors, setErrors] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    MENUCATNAME: "",
    MENUCATCODE: "",
    MENUTYPECODE: "",
  });
  const isEdit = location.state?.actionText === "Edit";

  const [error, setError] = useState({
    MENUCATNAME: "",
    MENUTYPECODE: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        MENUCATNAME: selectedItem.MENUCATNAME,
        MENUCATCODE: selectedItem.MENUCATCODE,
        MENUTYPECODE: selectedItem.MENUTYPECODE,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchData();
  }, []);

  //-----------functions------------------------------------
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_02, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  //handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    // Update the selected item details with the new input value
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };

  const handleAutocompleteChange = (event, newValue) => {
    setSelectedItemDetails({
      ...selectedItemDetails,
      MENUTYPECODE: newValue,
    });
  };
  //postapi
  const handleConfirmClick = async () => {
    const { MENUCATNAME, MENUTYPECODE } = selectedItemDetails;

    const requiredFields = [
      { name: "MENUTYPECODE", value: MENUTYPECODE, label: "Item Type" },
      { name: "MENUCATNAME", value: MENUCATNAME, label: " Catergory name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage);
      return;
    }

    // Check for duplicate MENUCATNAME
    const isDuplicate = data.some(
      (item) =>
        item.MENUCATNAME === MENUCATNAME &&
        item.MENUCATCODE !== selectedItemDetails.MENUCATCODE
    );

    if (isDuplicate) {
      setSnackbarMessage("Menu name already exists.");
      setOpenErrorSnackbar(true);
      return;
    }

    const menucatCode = selectedItem
      ? String(selectedItem.MENUCATCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,

      STS: CON_STATUS_ACTIVE,
      CHAINCODE,
      COLORCODE: "#ff80ff",
      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      MENUCATCODE: menucatCode,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_02, payload);
      console.log("Success:", responseData);

      setOpenSnackbar(true);

      setSelectedItemDetails({
        MENUTYPECODE: "",
        MENUCATNAME: "",
        MENUCATCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }

    setTimeout(() => {
      navigate("/vcategory");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      MENUTYPECODE: "",
      MENUCATNAME: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const gotToView = () => {
    navigate("/vcategory");
  };

  //validations
  const handleInputValidation = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
      handleInputChange(event);
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters and spaces are allowed.",
      }));
    }
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Category</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Category" : "Create Category" }}
        />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              options={names}
              getOptionLabel={(option) => option.label}
              value={
                names.find(
                  (option) => option.value === selectedItemDetails.MENUTYPECODE
                ) || null
              }
              onChange={(event, newValue) => {
                handleInputChange({
                  target: {
                    name: "MENUTYPECODE",
                    value: newValue ? newValue.value : "",
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Item Type<span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  size="small"
                  variant="outlined"
                  error={Boolean(errors.MENUTYPECODE)}
                  helperText={errors.MENUTYPECODE}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              noOptionsText={
                <div
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    padding: "8px",
                  }}
                >
                  No options
                </div>
              }
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Item Category<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="MENUCATNAME"
              value={selectedItemDetails.MENUCATNAME}
              onChange={handleInputValidation}
              error={Boolean(errors.MENUCATNAME)}
              helperText={errors.MENUCATNAME}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Category;
